/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react'
import { useFilterState, useSafeLayoutEffect } from '@vtex/admin-ui'
import { useLocalStorage } from '@/hooks/useLocalStorage'

export function useFilter(key: string) {
  const state = useFilterState<any>()

  const [appliedItem, setAppliedItem] = useLocalStorage(key, state.appliedItem)

  useSafeLayoutEffect(() => {
    if (!appliedItem) return

    state.combobox.setSelectedItem(appliedItem)
  }, [])

  const finalState = useMemo(
    () => ({
      ...state,
      appliedItem,
      hasFilterValueApplied: state.hasFilterValueApplied || !!appliedItem,
      setAppliedItem,
      onClear: () => {
        state.onClear()
        setAppliedItem(undefined)
      },
      onChange: () => {
        state.onChange()
        setAppliedItem(state.combobox.selectedItem)
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state, appliedItem]
  )

  return finalState
}
